import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { LoadingScreen } from "@/features/shell/LoadingScreen";
import { MobileGuard } from "@/features/shell/MobileGuard";
import { useIsMobile } from "@/features/shell/useIsMobile";
import { LegacyEventsBridge } from "./LegacyEventsBridge";
import { LegacyLanguageBridge } from "./LegacyLanguageBridge";
import { LegacyToastViewport } from "./legacySlots";
import { Providers } from "./providers";

/** Radice di tutte le rotte: provider, guard mobile, Suspense delle viste lazy, toast e host delle modali. */
export function Root() {
  return (
    <Providers>
      <LegacyLanguageBridge />
      <LegacyEventsBridge />
      <RootContent />
    </Providers>
  );
}

function RootContent() {
  if (useIsMobile()) return <MobileGuard />;
  return (
    <>
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
      <LegacyToastViewport />
      <div id="modal-root" data-theme="accela-donutwork" />
    </>
  );
}
